<ng-container *notInPopulation="[populations.Suite, populations.Pts]">
  <div class="d-block d-lg-none">
    <fgb-page-header [pageTitle]="'polls.page.title'" [backButtonLink]="'/games'" [showFooter]="false"></fgb-page-header>
  </div>

  <div class="games-banner bg-primary">
    <div class="container">
      <img src="assets/images/games/games-banner.jpg" alt="" />
    </div>
  </div>

  <div class="container polls-list-container">
    <ng-container *ngIf="pollsQuestion$ | async as pollsQuestions; else shimmerEffect">
      <fgbcl-game-polls-question-list [pollsQuestions]="pollsQuestions" (answerSelected)="onAnswerSelected($event)">
      </fgbcl-game-polls-question-list>
    </ng-container>

    <!-- Shimmer Effect -->
    <ng-template #shimmerEffect>
      <div class="card" aria-hidden="true" *ngFor="let i of [1, 2, 3]">
        <h6 class="card-title placeholder-glow text-center">
          <span class="question-shimmer-effect placeholder col-6"></span>
        </h6>
        <div class="answer-shimmer-effect-section">
          <p class="card-text placeholder-glow w-100 mb-0 text-center">
            <span class="answer-shimmer-effect placeholder col-12 bg-disabled"></span>
          </p>
          <p class="card-text placeholder-glow w-100 mb-0 text-center">
            <span class="answer-shimmer-effect placeholder col-12 bg-disabled"></span>
          </p>
        </div>
        <div class="answer-shimmer-effect-section mt-3">
          <p class="card-text placeholder-glow w-100 mb-0 text-center">
            <span class="answer-shimmer-effect placeholder col-12 bg-disabled"></span>
          </p>
          <p class="card-text placeholder-glow w-100 mb-0 text-center">
            <span class="answer-shimmer-effect placeholder col-12 bg-disabled"></span>
          </p>
        </div>
        <div class="d-flex align-items-center justify-content-center">
          <p class="card-text placeholder-glow w-40 text-center">
            <span class="presentby-shimmer-effect placeholder col-7"></span>
          </p>
        </div>
      </div>
    </ng-template>
  </div>
</ng-container>

<ng-container *inPopulation="[populations.Suite, populations.Pts]">
  <fgb-not-found-page></fgb-not-found-page>
</ng-container>
